module.exports = __webpack_public_path__ + "static/media/cloud-maliva.eb07c947.png";